<template>
  <div class="loading-container">
    <div class="loading-overlay"></div>
    <div class="loading-content"></div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
.loading-container {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* 遮罩层样式 */
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(5px);
  }
  /* 加载动画样式 */
  .loading-content {
    width: 40px;
    height: 40px;
    border: 3px solid #e0e0e0;
    border-top-color: #3498db;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
}
</style>